/**
 * Survey Configuration
 * Central configuration for survey behavior
 */

export const SURVEY_CONFIG = {
  /**
   * Survey status
   *
   * - 'open': Survey is active and accepting responses
   * - 'closed': Survey has ended, show closed message
   * - 'waiting': Survey hasn't started yet, show waiting message
   */
  STATUS: 'closed',

  /**
   * Message shown when survey is closed
   */
  CLOSED_MESSAGE: {
    title: 'Coleta Encerrada',
    description: 'A coleta de respostas do Retrato dos Consumidores de Cervejas 2026 já ocorreu. No momento estamos analisando os dados para apresentar o resultado.',
  },

  /**
   * Message shown when survey is waiting to begin
   */
  WAITING_MESSAGE: {
    title: 'Em Breve',
    description: 'A coleta de respostas do Retrato dos Consumidores de Cervejas 2026 começará em breve. Volte mais tarde para participar!',
  },
};
